"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    level = 1,
    color = themeColors?.general.text
  } = props;
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccTitleStyle = (0, _react.useMemo)(() => {
    const levelProps = () => {
      let fontSize;
      let lineHeight;
      switch (level) {
        case 1:
          {
            fontSize = pxToRem(32);
            lineHeight = pxToRem(32);
            break;
          }
        case 2:
          {
            fontSize = pxToRem(26);
            lineHeight = pxToRem(28);
            break;
          }
        case 3:
          {
            fontSize = pxToRem(22);
            lineHeight = pxToRem(24);
            break;
          }
        case 4:
          {
            fontSize = pxToRem(18);
            lineHeight = pxToRem(20);
            break;
          }
      }
      return {
        fontSize,
        lineHeight
      };
    };
    const ccTitle = (0, _css.css)({
      margin: 0,
      fontFamily: fontFamily,
      color: color,
      ...levelProps()
    });
    return {
      ccTitle
    };
  }, [fontFamily, level, pxToRem, color]);
  return {
    'cc-Title': ccTitleStyle.ccTitle
  };
};
var _default = exports.default = useStyles;